/** Порушення 422 так, як його віддає бек: поле (з індексом адреси) і текст. */
export interface LetterViolation {
    field: string
    message: string
}

/** Поля шухляди листа, під якими показуємо помилки бека. */
const FORM_FIELDS = new Set(['toWhom', 'cc', 'bcc', 'subject', 'body', 'attachments', 'scheduledAt'])

/**
 * Порушення з тіла 422 (`violations[]`, ядро кладе поле в `field` або
 * `propertyPath`). Індекс адреси (`toWhom[1]`, `cc.0`) зводиться до поля:
 * помилку видно під переліком, а текст бека називає саму адресу (§7.2).
 */
export const letterViolationsOf = (body: unknown): LetterViolation[] => {
    if (body === null || typeof body !== 'object') return []

    const raw = (body as Record<string, unknown>)['violations']

    if (!Array.isArray(raw)) return []

    return raw
        .map((item) => {
            const record = (item ?? {}) as Record<string, unknown>
            const path = typeof record['field'] === 'string' ? record['field'] : record['propertyPath']
            const message = record['message']

            return {
                field: typeof path === 'string' ? (path.split(/[[.]/)[0] ?? '') : '',
                message: typeof message === 'string' ? message : '',
            }
        })
        .filter((violation) => violation.message !== '')
}

/**
 * Помилки під поля форми: перша на поле виграє. Порушення поза формою
 * (автор без пошти чи пароля додатку) сюди не потрапляють — їх показує
 * повідомлення з текстом сервера.
 */
export const letterFieldErrors = (violations: readonly LetterViolation[]): Record<string, string> => {
    const errors: Record<string, string> = {}

    for (const { field, message } of violations) {
        if (FORM_FIELDS.has(field) && errors[field] === undefined) errors[field] = message
    }

    return errors
}
